import React from "react";
import Layout from "../components/Layout";

import DemoForm from "../components/DemoForm";

function Pricing() {
  return (
    <Layout>
      <div className="container py-5 text-center">
        <h1 className="mb-3">Simple, Scalable Pricing</h1>
        <p className="lead mb-4">
          WebVenly was designed for teams of all sizes — from small to large
          CRPs. Start small, scale up, and only pay for what you need.
        </p>
        <p className="mb-5">
          No hidden costs. Just powerful tools to streamline your workforce
          services — and flexible pricing that meets your organization’s size
          and goals.
        </p>

        {/* Contact Form CTA */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8">
            <h3>Let’s Talk Pricing</h3>
            <p>
              Fill out the form below and we’ll send you a custom quote based on
              your team size and feature needs.
            </p>
            <DemoForm />
            <p className="mt-3">
              Or reach out directly at{" "}
              <a href="mailto:support@webvenly.com">support@webvenly.com</a>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Pricing;
